/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_EmptyInputs */

const cs_billing_invoices_empty = /** @type {(inputs: Billing_Invoices_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné faktury.`)
};

const en_billing_invoices_empty = /** @type {(inputs: Billing_Invoices_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invoices yet.`)
};

/**
* | output |
* | --- |
* | "No invoices yet." |
*
* @param {Billing_Invoices_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoices_empty = /** @type {((inputs?: Billing_Invoices_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_invoices_empty(inputs)
	return cs_billing_invoices_empty(inputs)
});